/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {useState} from 'react';

import {DripSubscribeForm} from '../../adPages/DripSubscribeForm.client';

import {StandardModal} from '../../ui/standardModal.client';

export const ModalForm = ({linkText, form}: any) => {
  const [isOpen, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button className="btn-standard" onClick={() => setOpen(true)}>
        {linkText}
      </button>
      <StandardModal isOpen={isOpen}>
        <div
          onClick={onClose}
          className="absolute right-0 top-0 z-40 cursor-pointer p-6"
        >
          <div className="w-6">
            <svg
              className="rotate-45"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="transition-standard"
                d="M13 0C12.2238 0 11.5947 0.629119 11.5947 1.40531V11.5947H1.40531C0.629119 11.5947 0 12.2238 0 13C0 13.7762 0.629119 14.4053 1.40531 14.4053H11.5947V24.5947C11.5947 25.3709 12.2238 26 13 26C13.7762 26 14.4053 25.3709 14.4053 24.5947V14.4053H24.5947C25.3709 14.4053 26 13.7762 26 13C26 12.2238 25.3709 11.5947 24.5947 11.5947H14.4053V1.40531C14.4053 0.629119 13.7762 0 13 0Z"
                fill={'#F27021'}
              />
            </svg>
          </div>
        </div>
        <div>
          <DripSubscribeForm {...form} onClose={onClose} />
        </div>
      </StandardModal>
    </>
  );
};
